export default __webpack_public_path__ + "static/media/dashboardIllustration.d86946bc.png";